import { IsProd } from "@/constants/config";
import request from "@/utils/request";
const PATH_PREFIX = IsProd ? "/v1/" : "/vb/";

export interface PaymentSessionParams {
  type: "person" | "business";
  span: string; //"monthly" | "yearly";
}

export const paymentSession = (data: PaymentSessionParams) => {
  return request.post<PaymentSessionParams, { url: string }>(PATH_PREFIX + "payment_session", {
    ...data,
  });
};

export const paymentPortal = () => {
  return request.post<void, { url: string }>(PATH_PREFIX + "payment_portal", {});
};
